import MuiToggleButton, { ToggleButtonProps } from '@mui/material/ToggleButton';

export const ToggleButton: React.FC<ToggleButtonProps> = ({ ...props }) => {
  return <MuiToggleButton {...props}></MuiToggleButton>;
};
